import React from 'react';
import { motion } from 'framer-motion';
import { AnimatedIconProvider } from '@carnica/graphics';
import { cnBem } from "../../../../shared/lib";
import { BTN_TEXT_MORE_VARIANTS } from "../../../../shared/config";
import { useQuickReplies } from "../../lib";
import { QuickButton } from "../QuickButton";
import styles from "./styles.pcss";
var cnQuickReplies = cnBem('quick-replies', styles);
var Reply = function Reply(_ref) {
  var item = _ref.item,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(QuickButton, {
    icon: item.imageUrl,
    isDeepLink: !!item.deepLink,
    link: item.deepLink || item.link,
    onClick: onClick,
    title: item.text,
    "data-t-id": "ui-QuickReplies"
  });
};
export var QuickReplies = function QuickReplies(_ref2) {
  var items = _ref2.items,
    onItemClick = _ref2.onItemClick,
    className = _ref2.className;
  var _useQuickReplies = useQuickReplies(items),
    flexListByPage = _useQuickReplies.flexListByPage,
    fixedList = _useQuickReplies.fixedList,
    isMoreVariant = _useQuickReplies.isMoreVariant,
    onClick = _useQuickReplies.onClick,
    IconComponent = _useQuickReplies.IconComponent,
    hasMoreVariants = _useQuickReplies.hasMoreVariants;
  var handleClick = function handleClick(item) {
    return function () {
      return onItemClick(item);
    };
  };
  return /*#__PURE__*/React.createElement("section", {
    className: cnQuickReplies(null, [className])
  }, !!(flexListByPage !== null && flexListByPage !== void 0 && flexListByPage.length) && /*#__PURE__*/React.createElement(motion.div, {
    className: cnQuickReplies('list')
  }, flexListByPage.map(function (item, i) {
    return /*#__PURE__*/React.createElement(Reply, {
      item: item,
      key: cnQuickReplies('item', {
        i: i
      }),
      onClick: handleClick(item)
    });
  }), isMoreVariant && /*#__PURE__*/React.createElement(AnimatedIconProvider, {
    activeIndex: hasMoreVariants ? 0 : 1
  }, /*#__PURE__*/React.createElement(QuickButton, {
    className: cnQuickReplies('item-more'),
    icon: IconComponent,
    onClick: onClick,
    title: BTN_TEXT_MORE_VARIANTS,
    "data-t-id": "ui-QuickReplies"
  }))), !!(fixedList !== null && fixedList !== void 0 && fixedList.length) && /*#__PURE__*/React.createElement("div", {
    className: cnQuickReplies('list')
  }, fixedList.map(function (item, i) {
    return /*#__PURE__*/React.createElement(Reply, {
      item: item,
      key: cnQuickReplies('item', {
        i: i
      }),
      onClick: handleClick(item)
    });
  })));
};